<div class="breadcrumb-area">
  <h1>Reportes Varios (Maye)</h1>
</div>
<!-- 
<div class="card mb-3" id="mayeVariousReport">
  <div class="title-report card-header d-flex justify-content-between align-items-center"
       (click)="toggleSection()">
    <h3>Pedidos de Venta Reservados</h3>
    <h3>
      <i [ngClass]="isOpen ? 'fa-minus' : 'fa-plus'" class="fa"></i>
    </h3>
  </div>

  <div class="card-body" *ngIf="isOpen">
    <div class="row mb-3">
      <div class="col-sm-12 text-muted">
        <i class="fa fa-circle-info"></i>
        Este reporte muestra los pedidos de venta reservados de la empresa actual.
        Puedes descargarlo en formato Excel.
      </div>
    </div>

    <div class="col-sm download-buttons d-flex gap-2 align-items-end justify-content-end mb-3">
        <button class="btn btn-success" (click)="downloadReport('excel')"
                [disabled]="btnExcel.loading">
          <i *ngIf="!btnExcel.loading" class="fa fa-file-excel"></i>
          <span *ngIf="btnExcel.loading" class="spinner-border spinner-border-sm"></span>
        </button>
        <button class="btn btn-secondary"
                (click)="downloadReportJson()"
                [disabled]="btnJson.loading">
          <i *ngIf="!btnJson.loading" class="fa fa-eye"></i>
          <span *ngIf="btnJson.loading"
                class="spinner-border spinner-border-sm"></span>
        </button>
      </div>
      <div class="row mb-3">
        <app-order-of-orders-sale-preview [data]="ordersSaleData"></app-order-of-orders-sale-preview>
      </div>
    </div>
</div>
<div class="card mb-3" id="mayeSalesBook">

  <div class="title-report card-header d-flex justify-content-between align-items-center"
       (click)="toggleSalesBook()">
    <h3>Libro de Ventas (por Destino)</h3>
    <h3>
      <i [ngClass]="isSalesBookOpen ? 'fa-minus' : 'fa-plus'" class="fa"></i>
    </h3>
  </div>

  <div class="card-body" *ngIf="isSalesBookOpen">

    <div class="row mb-3">
      <div class="col-sm-4">
        <div class="form-group">
          <label for="startDateSales" class="form-label">Fecha Inicial:</label>
          <input type="date" [(ngModel)]="startDateSales" id="startDateSales" class="form-control">
        </div>
      </div>

      <div class="col-sm-4">
        <div class="form-group">
          <label for="endDateSales" class="form-label">Fecha Final:</label>
          <input type="date" [(ngModel)]="endDateSales" id="endDateSales" class="form-control">
        </div>
      </div>
      
      <div class="col-sm-4">
        <label class="form-label">Destino:</label>
        
      <div class="col-sm">
				<app-input-autocomplete-selection 
            [inputs]="inputsDestination.destination" 
            [placeholder]="'Ingresa id o nombre de un destino'"
            [filterElements]="destinationFilter" 
            [typeElements]="'destination'"
            [enableSelect]="true" 
            (inputMethod)="handleInput($event.event, 'destination')"
            (changeMethod)="verifiedInput($event.event, 'destination')"
            (changeStatus)="changeStatusInput($event.filterElement, '', 1, 'destination')"
            (getTitle)="
                $event.filterElement.title = $event.filterElement.name
            ">
            </app-input-autocomplete-selection>
			</div>
  
        <small class="text-muted" *ngIf="!inputs.destination.verified && inputs.destination.value">
          Selecciona un destino válido de la lista.
        </small>
      </div>
    </div>

    <div class="col-sm download-buttons d-flex gap-2 align-items-end justify-content-end mb-3">
        <button class="btn btn-success"
                (click)="downloadSalesBook('excel')"
                [disabled]="btnSalesExcel.loading">
          <i *ngIf="!btnSalesExcel.loading" class="fa fa-file-excel"></i>
          <span *ngIf="btnSalesExcel.loading" class="spinner-border spinner-border-sm"></span>
        </button>

       <button class="btn btn-secondary"
                (click)="downloadSalesBook('json')"
                [disabled]="btnSalesJson.loading">
          <i *ngIf="!btnSalesJson.loading" class="fa fa-eye"></i>
          <span *ngIf="btnSalesJson.loading" class="spinner-border spinner-border-sm"></span>
        </button>
    </div>

    <div class="row mb-3">
      <app-sales-book-maye-preview [data]="salesBookData"></app-sales-book-maye-preview>
    </div>
  </div>
</div> -->

<!-- <div class="card mb-3" id="utilityReportMaye">
  <div class="title-report card-header d-flex justify-content-between align-items-center"
       (click)="toggleUtilityReport()">
    <h3>Margen de Utilidad y Reportería (por Destino)</h3>
    <h3><i [ngClass]="isUtilityOpen ? 'fa-minus' : 'fa-plus'" class="fa"></i></h3>
  </div>

  <div class="card-body" *ngIf="isUtilityOpen">
    <div class="row">
      <div class="col-sm-2">
        <div class="form-group">
          <label for="startDateUtility" class="form-label">Fecha Inicial:</label>
          <input type="date" [(ngModel)]="startDateUtility" id="startDateUtility"
                 class="form-control">
        </div>
      </div>

      <div class="col-sm-2">
        <div class="form-group">
          <label for="endDateUtility" class="form-label">Fecha Final:</label>
          <input type="date" [(ngModel)]="endDateUtility" id="endDateUtility"
                 class="form-control">
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group">
          <label for="productUtility-input" class="form-label">Producto:</label>
          <div class="input-group input-group-sm">
            <app-input-autocomplete
              [allBorderRadius]="true"
              [inputs]="inputs.productKardex"
              [placeholder]="'Código o nombre de producto'"
              [filterElements]="productFilter"
              [typeElements]="'productUtility'"
              (inputMethod)="writeProductKardex($event.event)"
              (getTitle)="$event.filterElement.title = $event.filterElement.name"
              (changeStatus)="selectProduct($event.filterElement)">
            </app-input-autocomplete>
          </div>
          <small class="text-muted">Opcional: deja vacío para todos los productos.</small>
        </div>
      </div>
      
      <div class="col-sm-2">
        <label class="form-label">Ubicación:</label>

        <div class="input-group bg-white rounded">
          <app-input-autocomplete
            [allBorderRadius]="true"
            [inputs]="inputs.place"
            [placeholder]="'Ingresa una ubicación'"
            [filterElements]="filterPlaces"
            (inputMethod)="writePlace($event.event)"
            (changeStatus)="checkPlace($event.filterElement)"
            (getTitle)="$event.filterElement.title = $event.filterElement.name"
          ></app-input-autocomplete>
        </div>

        <small class="text-muted" *ngIf="!inputs.place.verified && inputs.place.value">
          Selecciona una ubicación válida de la lista.
        </small>
      </div>
      <div class="col-sm-3">
        <div class="col-sm">
          <label class="form-label">Destino:</label>
          <app-input-autocomplete-selection 
            [inputs]="inputsDestination.destinationMargin" 
            [placeholder]="'Ingresa id o nombre de un destino'"
            [filterElements]="destinationFilterMargin" 
            [typeElements]="'destination'"
            [enableSelect]="true" 
            (inputMethod)="handleInput($event.event, 'destination')"
            (changeMethod)="verifiedInput($event.event, 'destination')"
            (changeStatus)="changeStatusInput($event.filterElement, '', 1, 'destinationMargin')"
            (getTitle)="
                $event.filterElement.title = $event.filterElement.name
            ">
            </app-input-autocomplete-selection>
        </div>
      </div>
    </div>

      <div class="row mb-3">

      <div class="col-sm download-buttons d-flex gap-2 align-items-end justify-content-end mb-3">
        <button class="btn btn-success"
                (click)="getProfitMarginReport('excel')"
                [disabled]="btnUtilityExcel.loading"
                data-bs-toggle="tooltip" title="Descargar Excel">
          <i *ngIf="!btnUtilityExcel.loading" class="fa fa-file-excel"></i>
          <span *ngIf="btnUtilityExcel.loading" class="spinner-border spinner-border-sm"></span>
        </button>

        <button class="btn btn-secondary"
                (click)="getProfitMarginReport('json')"
                [disabled]="btnUtilityJson.loading"
                data-bs-toggle="tooltip" title="Ver data">
          <i *ngIf="!btnUtilityJson.loading" class="fa fa-eye"></i>
          <span *ngIf="btnUtilityJson.loading" class="spinner-border spinner-border-sm"></span>
        </button>
      </div>
    </div>
    <div class="row mb-3">
      <app-profit-margin-maye-preview [data]="utilityReportData"></app-profit-margin-maye-preview>
    </div>
  </div>
</div> -->

<div class="card mb-3" id="mayeExistenceByPlace">

  <div class="title-report card-header d-flex justify-content-between align-items-center"
       (click)="togglePlaceExistence()">
    <h3>Existencia por Ubicación</h3>
    <h3><i [ngClass]="isPlaceExistenceOpen ? 'fa-minus' : 'fa-plus'" class="fa"></i></h3>
  </div>

  <div class="card-body" *ngIf="isPlaceExistenceOpen">

    <div class="row mb-3">
      <div class="col-sm-12 text-muted">
        <i class="fa fa-circle-info"></i>
        Este reporte muestra la existencia de productos por contenedor para una ubicación.
        Puedes descargarlo en Excel.
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-6">
        <div class="form-group">
          <label for="endDatePlaceExistence" class="form-label">Fecha:</label>
          <input type="date" [(ngModel)]="endDatePlaceExistence" id="endDatePlaceExistence"
                 class="form-control">
        </div>
      </div>
      <div class="col-sm-6">
        <label class="form-label">Ubicación:</label>

        <div class="input-group bg-white rounded">
          <app-input-autocomplete
            [allBorderRadius]="true"
            [inputs]="inputs.place"
            [placeholder]="'Ingresa una ubicación'"
            [filterElements]="filterPlaces"
            (inputMethod)="writePlace($event.event)"
            (changeStatus)="checkPlace($event.filterElement)"
            (getTitle)="$event.filterElement.title = $event.filterElement.name"
          ></app-input-autocomplete>
        </div>

        <small class="text-muted" *ngIf="!inputs.place.verified && inputs.place.value">
          Selecciona una ubicación válida de la lista.
        </small>
      </div>
    </div>

    <div class="col-sm download-buttons d-flex gap-2 align-items-end justify-content-end mb-3">
      <button class="btn btn-success"
              (click)="downloadExistenceByPlace('excel')"
              [disabled]="btnPlaceExcel.loading">
        <i *ngIf="!btnPlaceExcel.loading" class="fa fa-file-excel"></i>
        <span *ngIf="btnPlaceExcel.loading" class="spinner-border spinner-border-sm"></span>
      </button>

      <button class="btn btn-secondary"
              (click)="downloadExistenceByPlace('json')"
              [disabled]="btnPlaceJson.loading">
        <i *ngIf="!btnPlaceJson.loading" class="fa fa-eye"></i>
        <span *ngIf="btnPlaceJson.loading" class="spinner-border spinner-border-sm"></span>
      </button>
    </div>

    <div class="row mb-3">
      <app-existences-by-place-maye-preview [data]="existencesPlaceData"></app-existences-by-place-maye-preview>
    </div>

  </div>
</div>


<!-- <div class="card mb-3" id="balanceReportMaye">
  <div class="title-report card-header d-flex justify-content-between align-items-center"
       (click)="toggleBalacenPlaceReport()">
    <h3>Saldos por Ubicación y Destino</h3>
    <h3><i [ngClass]="isBalacenPlaceOpen ? 'fa-minus' : 'fa-plus'" class="fa"></i></h3>
  </div>

  <div class="card-body" *ngIf="isBalacenPlaceOpen">
    <div class="row">
      <div class="col-sm">
        <div class="form-group">
          <label for="startDateBalacenPlace" class="form-label">Fecha Inicial:</label>
          <input type="date" [(ngModel)]="startDateBalacenPlace" id="startDateBalacenPlace"
                 class="form-control">
        </div>
      </div>

      <div class="col-sm">
        <div class="form-group">
          <label for="endDateBalacenPlace" class="form-label">Fecha Final:</label>
          <input type="date" [(ngModel)]="endDateBalacenPlace" id="endDateBalacenPlace"
                 class="form-control">
        </div>
      </div>

      <div class="col-sm download-buttons d-flex gap-2 align-items-end">
        <button class="btn btn-success"
                (click)="getBalancePlaceReport('excel')"
                [disabled]="btnBalacenPlaceExcel.loading"
                data-bs-toggle="tooltip" title="Descargar Excel">
          <i *ngIf="!btnBalacenPlaceExcel.loading" class="fa fa-file-excel"></i>
          <span *ngIf="btnBalacenPlaceExcel.loading" class="spinner-border spinner-border-sm"></span>
        </button>

        <button class="btn btn-secondary"
                (click)="getBalancePlaceReport('json')"
                [disabled]="btnBalacenPlaceJson.loading"
                data-bs-toggle="tooltip" title="Visualizar">
          <i *ngIf="!btnBalacenPlaceJson.loading" class="fa fa-eye"></i>
          <span *ngIf="btnBalacenPlaceJson.loading" class="spinner-border spinner-border-sm"></span>
        </button>
      </div>
    </div>
    <app-place-destination-maye-preview
      [report]="balancePlacePreview"
      [loading]="loadingBalancePlacePreview">
    </app-place-destination-maye-preview>
  </div>
</div> -->


<!-- <div class="card mb-3" id="resultReportMaye">
  <div class="title-report card-header d-flex justify-content-between align-items-center"
       (click)="toggleResultPlaceReport()">
    <h3>Resultados por Ubicación y Destino</h3>
    <h3><i [ngClass]="isResultPlaceOpen ? 'fa-minus' : 'fa-plus'" class="fa"></i></h3>
  </div>

  <div class="card-body" *ngIf="isResultPlaceOpen">
    <div class="row mb-3">
      <div class="col-sm">
        <div class="form-group">
          <label for="startDateResultPlace" class="form-label">Fecha Inicial:</label>
          <input type="date" [(ngModel)]="startDateResultPlace" id="startDateResultPlace"
                 class="form-control">
        </div>
      </div>

      <div class="col-sm">
        <div class="form-group">
          <label for="endDateResultPlace" class="form-label">Fecha Final:</label>
          <input type="date" [(ngModel)]="endDateResultPlace" id="endDateResultPlace"
                 class="form-control">
        </div>
      </div>

      <div class="col-sm download-buttons d-flex gap-2 align-items-end">
        <button class="btn btn-success"
                (click)="getResultPlaceReport('excel')"
                [disabled]="btnResultPlaceExcel.loading"
                data-bs-toggle="tooltip" title="Descargar Excel">
          <i *ngIf="!btnResultPlaceExcel.loading" class="fa fa-file-excel"></i>
          <span *ngIf="btnResultPlaceExcel.loading" class="spinner-border spinner-border-sm"></span>
        </button>

        <button class="btn btn-secondary"
                (click)="getResultPlaceReportJson('json')"
                [disabled]="btnResultPlaceJson.loading"
                data-bs-toggle="tooltip" title="Visualizar Datos">
          <i *ngIf="!btnResultPlaceJson.loading" class="fa fa-eye"></i>
          <span *ngIf="btnResultPlaceJson.loading" class="spinner-border spinner-border-sm"></span>
        </button>
      </div>
    </div>
    <div class="row mb-3">
      <app-result-place-maye-preview [data]="resultPlaceData"></app-result-place-maye-preview>
    </div>
  </div>
</div> -->

<!-- <div class="card mb-3" id="clientDestinationBalanceReport">
  <div class="title-report card-header d-flex justify-content-between align-items-center"
       (click)="isClientDestinationBalanceOpen = !isClientDestinationBalanceOpen">
    <h3>Saldos de Clientes por Destino</h3>
    <h3>
      <i [ngClass]="isClientDestinationBalanceOpen ? 'fa-minus' : 'fa-plus'" class="fa"></i>
    </h3>
  </div>

  <div class="card-body" *ngIf="isClientDestinationBalanceOpen">

    <div class="row mb-3">
      <div class="col col-sm-4">
        <label class="form-label">Fecha Inicial:</label>
        <input type="date"
               [(ngModel)]="startDateClientDestination"
               class="form-control">
      </div>

      <div class="col col-sm-4">
        <label class="form-label">Fecha Final:</label>
        <input type="date"
               [(ngModel)]="endDateClientDestination"
               class="form-control">
      </div>
      
      <div class="col col-sm-4">

        <div class="col-sm">
          <label class="form-label">Destino:</label>
          <app-input-autocomplete-selection 
            [inputs]="inputsDestination.destinationBalance" 
            [placeholder]="'Ingresa id o nombre de un destino'"
            [filterElements]="destinationFilterBalance" 
            [typeElements]="'destination'"
            [enableSelect]="true" 
            (inputMethod)="handleInput($event.event, 'destination')"
            (changeMethod)="verifiedInput($event.event, 'destination')"
            (changeStatus)="changeStatusInput($event.filterElement, '', 1, 'destinationBalance')"
            (getTitle)="
                $event.filterElement.title = $event.filterElement.name
            ">
            </app-input-autocomplete-selection>
        </div>
      </div>
    </div>

    <div class="col-sm download-buttons d-flex gap-2 align-items-end justify-content-end mb-3">
        <button class="btn btn-success"
                (click)="getClientDestinationBalanceReport('excel')"
                [disabled]="btnClientDestinationExcel.loading">
          <i *ngIf="!btnClientDestinationExcel.loading" class="fa fa-file-excel"></i>
          <span *ngIf="btnClientDestinationExcel.loading"
                class="spinner-border spinner-border-sm"></span>
        </button>
        <button class="btn btn-secondary"
                (click)="getClientDestinationBalanceReport('json')"
                [disabled]="btnClientDestinationJson.loading">
          <i *ngIf="!btnClientDestinationJson.loading" class="fa fa-eye"></i>
          <span *ngIf="btnClientDestinationJson.loading"
                class="spinner-border spinner-border-sm"></span>
        </button>
    </div>

    <div class="row mb-3">
      <app-client-destination-maye-preview [data]="clientDestinationData"></app-client-destination-maye-preview>
    </div>

  </div>
</div> -->

<div class="card mb-3" id="generalTable">
  <div class="title-report card-header d-flex justify-content-between align-items-center"
       (click)="toggleGeneralTable()">
    <h3>Tabla General</h3>
    <h3><i [ngClass]="isGeneralTable ? 'fa-minus' : 'fa-plus'" class="fa"></i></h3>
  </div>

  <div class="card-body" *ngIf="isGeneralTable">
    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label for="startGeneralTable" class="form-label">Fecha Inicial:</label>
          <input type="date" [(ngModel)]="startDateGeneralTable" id="startGeneralTable"
                 class="form-control">
        </div>
      </div>

      <div class="col-md-4">
        <div class="form-group">
          <label for="endGeneralTable" class="form-label">Fecha Final:</label>
          <input type="date" [(ngModel)]="endDateGeneralTable" id="endGeneralTable"
                 class="form-control">
        </div>
      </div>

      <div class="col-sm download-buttons d-flex gap-2 align-items-end justify-content-end mb-3">
        <button class="btn btn-success"
                (click)="getGeneralTable('excel')"
                [disabled]="btnExcelGeneralTable.loading"
                data-bs-toggle="tooltip" title="Descargar Excel">
          <i *ngIf="!btnExcelGeneralTable.loading" class="fa fa-file-excel"></i>
          <span *ngIf="btnExcelGeneralTable.loading" class="spinner-border spinner-border-sm"></span>
        </button>

        <button class="btn btn-secondary"
                (click)="getGeneralTable('json')"
                [disabled]="btnJsonGeneralTable.loading"
                data-bs-toggle="tooltip" title="Ver data">
          <i *ngIf="!btnJsonGeneralTable.loading" class="fa fa-eye"></i>
          <span *ngIf="btnJsonGeneralTable.loading" class="spinner-border spinner-border-sm"></span>
        </button>
      </div>

    </div>
    <div class="row mb-3">
      <app-general-table-preview [data]="generalTableReportData" [loading]="btnJsonGeneralTable.loading"></app-general-table-preview>
    </div>
  </div>
</div>

<!-- <div class="card mb-3" id="administrativeInvoices">
  <div class="title-report card-header d-flex justify-content-between align-items-center"
       (click)="toggleAdministrativeInvoices()">
    <h3>Facturas Administrativas</h3>
    <h3><i [ngClass]="isAdministrativeInvoicesOpen ? 'fa-minus' : 'fa-plus'" class="fa"></i></h3>
  </div>

  <div class="card-body" *ngIf="isAdministrativeInvoicesOpen">
    <div class="row mb-3">
      <div class="col-sm-12 text-muted">
        <i class="fa fa-circle-info"></i>
        Este reporte muestra las facturas administrativas en el rango de fechas seleccionado.
        Puedes descargarlo en Excel.
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label for="startAdminInv" class="form-label">Fecha Inicial:</label>
          <input type="date" [(ngModel)]="startDateAdministrativeInvoices"
                 id="startAdminInv" class="form-control">
        </div>
      </div>

      <div class="col-md-4">
        <div class="form-group">
          <label for="endAdminInv" class="form-label">Fecha Final:</label>
          <input type="date" [(ngModel)]="endDateAdministrativeInvoices"
                 id="endAdminInv" class="form-control">
        </div>
      </div>

      <div class="col-sm download-buttons d-flex gap-2 align-items-end justify-content-end mb-3">
        <button class="btn btn-success"
                (click)="downloadAdministrativeInvoices('excel')"
                [disabled]="btnAdministrativeInvoicesExcel.loading"
                data-bs-toggle="tooltip" title="Descargar Excel">
          <i *ngIf="!btnAdministrativeInvoicesExcel.loading" class="fa fa-file-excel"></i>
          <span *ngIf="btnAdministrativeInvoicesExcel.loading" class="spinner-border spinner-border-sm"></span>
        </button>

        <button class="btn btn-secondary"
                (click)="downloadAdministrativeInvoices('json')"
                [disabled]="btnAdministrativeInvoicesJson.loading"
                data-bs-toggle="tooltip" title="Ver data">
          <i *ngIf="!btnAdministrativeInvoicesJson.loading" class="fa fa-eye"></i>
          <span *ngIf="btnAdministrativeInvoicesJson.loading" class="spinner-border spinner-border-sm"></span>
        </button>
      </div>
    </div>

    
    <div class="row mb-3">
      <app-administrative-invoices-preview [data]="administrativeInvoicesData"></app-administrative-invoices-preview>
    </div>
   
  </div>
</div> -->
